export const environment = {
    production: true,
    apiUrl: 'https://ncmspvm.westeurope.cloudapp.azure.com/web/api/', // Direct backend URL
    deploymentEnv: 'production',
    oldVersionUrl: 'https://old-ncms.courts.gov.ng'

  };
  